(() => {
  'use strict';
  // The approved pictures in their own pixels: desktop/tablet = Josh's 10/16 lock (1274 px window, band 1274 x 335),
  // phone = his 440 px iPhone (band 440 x 210). unit = px per LAYOUT size in that frame. Every window draws the frame
  // scaled by s = band height / frame height (CSS keeps the band no taller than the frame's shape). Spare width spreads
  // the spots apart evenly, up to SPREAD; past that the picture stays centred with open sky at the sides.
  const FRAME = {
    // heroH = the hero's height at the lock (hero top to trust line), what the wings were arranged beside.
    desktop: { w: 1274, h: 335.05, unit: 12.7273, pad: 16, heroH: 339 },
    phone: { w: 440, h: 210, unit: 4.14133, pad: 4 }
  };
  const SPREAD = 1.25;
  const phoneQuery = matchMedia('(max-width: 720px)');
  // s scales the frame to this band; sx is the horizontal scale, the same as s plus any even spread (<= SPREAD).
  // home-parachute.js uses it too, so the parcel's start stays in the same spot of the picture.
  function frameFor(rect) {
    const f = phoneQuery.matches ? FRAME.phone : FRAME.desktop;
    const s = Math.min(rect.height / f.h, rect.width / f.w);
    return { f, s, sx: s * Math.min(SPREAD, Math.max(1, rect.width / (f.w * s))) };
  }
  window.VPHomeFrame = frameFor;
  window.VPHomeCollage = build;
  build();
  liveHand();

  // The pointing hand by the CTA slides in and straightens onto the button as the page scrolls.
  function liveHand() {
    const hand = document.querySelector('.home-page .hero-side-icon.hand');
    if (!hand) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let frame = 0;
    const update = () => {
      frame = 0;
      const progress = reduced.matches ? 1 : Math.max(0, Math.min(1, scrollY / 260));
      hand.style.setProperty('--hand-p', progress.toFixed(3));
      hand.classList.toggle('is-pointing', progress > .98);
    };
    addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, { passive: true });
    reduced.addEventListener?.('change', update);
    update();
  }

  function build() {
  // Homepage sticker bomb: VINYLPAC-owned artwork only (Yuliia's New England set in
  // assets/vp-stickers + our own VP finish renders). Replaces the compact header's
  // slot stickers on the homepage; product pages keep header.html as-is.
  const header = document.getElementById('library-header');
  const artwork = header?.querySelector('.library-artwork');
  if (!artwork || !document.body.classList.contains('home-page') || artwork.dataset.collage) return;
  artwork.dataset.collage = 'on';

  // VP logos come ONLY from the builder's clean 3D renders (never the old uploaded sticker photos),
  // one per finish, so the finishes read as samples instead of the same logo repeated.
  const FILES = {
    holo: [(window.VP_CDN+"specialty-exports__webp__holo__holo-prismatic__none__v1.webp?v=061e1820ed"), 1631, 1384],
    chrome: [(window.VP_CDN+"home-refinement__header-chrome-front.webp?v=44f9f22e07"), 1632, 1210],
    gold: [(window.VP_CDN+"home-refinement__header-gold-front.webp?v=0f1cc0d5ce"), 1632, 1210]
  };
  const SIZES = {
    'vp-black': [720, 360], lobster: [526, 720], duck: [720, 620], seagull: [720, 591],
    cardinal: [720, 368], dog: [514, 720], lighthouse: [544, 720], flower: [578, 720],
    pinetree: [345, 720], bird: [720, 369], mountain: [720, 492], 'vp-white': [720, 360],
    'vp-glass': [720, 352], clouds: [720, 375], 'wordmark-glass': [720, 191], loon: [720, 474],
    pumpkin: [720, 596], scene: [720, 720], fang: [699, 900],
    turkey: [896, 745], corn: [629, 896], sun: [896, 893]
  };
  // [name, desktop [x%, y%, size, angle, z] or null = phone only, phone [...] or null = desktop only].
  // 10/17 (Josh: "absolutely perfect at any size"): every spot is in a FRAME (below) = the picture Josh
  // approved, in its own pixels. x/y are % of that frame's band, size is in frame units. Any other window
  // shows the same picture scaled, so stickers never regroup or get shoved around at odd window shapes.
  // Desktop y above 100 is a hero wing beside the headline and CTA (hidden under WINGS_MIN):
  // 100 = top of the hero, 200 = the trust-row line, so wings track the hero copy, not the band height.
  // Desktop = Josh's own drag-arranged header (10/08 screenshot, 1533px window): an airy ring
  // around the wordmark and headline; scene + pumpkin are phone-only, the cosmic VP is out,
  // and the duck replaces the loon (his call). 10/12: Fang's wing moved down and right per his drag.
  // Phone (<=720px) = Josh's own drag arrangement (10/11 1:20 PM screenshot), then his 10/12 notes:
  // no pause button, so the top row (holo VP, clouds, cardinal, gold VP) spreads out evenly; the pumpkin
  // and flower a hair smaller; the cardinal keeps its top-row spot and swings in as the parachute drops
  // (swingIn below). No stained-glass scene, no Fang's head on the phone.
  // 10/12 later: the brown bird joins the phone layout right of the VINYLPAC plate (Josh marked the spot), nothing removed.
  // 10/12: top-left holo VP a bit larger and lower, centred in its corner (3 px plate gap, 'tight-plate'); top-right gold VP
  // turned counter-clockwise to -2 deg. GPT Sol picked these from rendered options; no other sticker moves.
  // 10/16 desktop = Josh's fall drag (2:42 PM screenshot, ~1274px window): turkey, corn and the plain pumpkin in the wings,
  // the holo VP phone-only, Fang off the page. Matched from his screenshot; sizes and angles unchanged.
  // 10/17: seagull, turkey and corn are their as-seen spots at that lock (the old pass had slid them off their rows).
  // 10/17 phone rows = exactly what his 440 px iPhone showed (the old nudge pass had moved the flower, duck, holo VP,
  // gold VP and brown bird off their table spots and shrunk the bird and duck; these rows are those as-seen spots).
  const LAYOUT = [
    ['chrome', [9.3, 38, 13.5, -5, 4], null],
    ['lighthouse', [22.8, 35.9, 6.6, -2, 8], null],
    ['clouds', [36.6, 15.1, 10, 4, 3], [37, 12.2, 18, 3, 4]],
    ['cardinal', [53, 14.3, 11.5, 3, 7], [63, 12.1, 19, 3, 6]],
    ['bird', [78.6, 29.3, 10.5, -3, 6], [92.5, 49, 13.26, -3, 6]],
    ['gold', [90.8, 29.6, 14.5, 2, 5], [88, 15.1, 17, -2, 5]],
    ['flower', [6.6, 85, 8, -4, 6], [8.8, 84.1, 15.5, -4, 6]],
    ['lobster', [18.7, 79, 6.6, 4, 8], null],
    ['duck', [35.3, 88.3, 8.5, 4, 7], [38.9, 86.9, 16.93, 4, 7]],
    ['mountain', [55.2, 89.5, 10.5, 1, 6], null],
    ['seagull', [85.13, 67.7, 8.4, -5, 8], null],
    // 10/17 Josh (1:41 PM screenshot, 1704 px window): "i moved the tree out for now" (pinetree was [93.6, 137.9, 5.6, -4, 7]).
    ['holo', null, [12.3, 17.7, 19.51, -4, 5], 'tight-plate'],
    ['dog', [6.2, 165.5, 8.6, 3, 5], null],
    // Fall 2026 (Josh 10/16): turkey, corn and Yuliia's plain pumpkin (never the VINYLPAC pumpkin here) join the desktop hero wings.
    // 10/17: corn a little left and the pumpkin out into the tree's old corner, from the same screenshot.
    ['turkey', [20.49, 138.15, 9, -4, 7], null],
    ['corn', [81.9, 119.6, 6.5, 5, 7], null],
    ['pumpkin', [91.4, 155.5, 9, 3, 6], null],
    ['pumpkin', null, [70, 86.2, 16.49, 4, 7]],
    // Phone (Josh 10/12): a second cloud drifts into the parachute's starting spot (below the brown bird, right of the
    // pumpkin) as the parachute drops away, so the band never shows a hole there.
    ['clouds', null, [92, 81, 12.99, -2, 4], 'fill-fall'],
    // Phone (Josh 10/17): a small sun (Yuliia's, after the corn and the brown dog: "spot and size is good… try the sun") fills
    // the hole left of "MADE EASY", just above the truck, opposite the parachute; it rolls in from the left edge as the
    // parachute drops (arriveOnDrop below).
    // Phone y above 100 = hero spot like the desktop wings (100 = hero top, 200 = trust-row line).
    ['sun', null, [15, 139.1, 7.4, 0, 6]],
    // Desktop (Josh 10/19, live site: "to the right of average fulfilment hours there's like a hole in the hero - the
    // parachute falls into the hole"): the same sun sits in the parachute's landing spot (right of the Saco line, left of
    // the corn) so the picture never shows a hole. As the parcel starts its scroll-driven fall, the sun rolls down and
    // right, bounces off the band's right edge under the pumpkin and rolls off the bottom (leaveOnFall below).
    // 'fill-fall' = the fall path is not a rock for it (like the phone fill cloud).
    // 10/19 05:40 Josh dragged it to its spot (1530 px window): right of the fulfillment line, a little below the Saco
    // line, so its rocks are the words themselves (sunRocks), not the 600 px copy column.
    ['sun', [70.5, 155, 6.5, 0, 6], null, 'fill-fall']
  ];
  // The accent stars (.home-spark in home.html) ride the same frames: [class, desktop [x, y, size], phone [...] or null].
  // Stars below the band (y > 100) belong to the wings and show only when the wings do.
  const SPARKS = [
    ['s1', [44, 25.77, 2.2], [44, 34.67, 4.35]],
    ['s2', [73, 114.62, 2.8], null],
    ['s3', [12, 147.05, 1.9], [8, 125.46, 3.86]],
    ['s4', [76, 177.16, 1.6], null]
  ];
  const WINGS_MIN = 721;
  let geom = null; // last layout pass's geometry, for arrange mode's Copy layout
  const phone = phoneQuery;

  artwork.querySelectorAll('.library-sticker,.library-spark').forEach(element => element.remove());
  const fragment = document.createDocumentFragment();
  const items = [];
  LAYOUT.forEach(([name, desk, mob, role], index) => {
    const [full, width, height] = FILES[name] || [(window.VP_CDN+"vp-stickers__") + name + '.webp', ...SIZES[name]];
    const sticker = document.createElement('div');
    // Desktop y > 100 = hero wing: hangs down beside the headline and CTA (wide screens only).
    sticker.className = 'library-sticker vp-bomb' + (mob ? '' : ' vp-bomb-desk') + (desk ? '' : ' vp-bomb-phone') + (desk && desk[1] > 100 ? ' vp-bomb-wing' : '');
    const set = (prefix, [x, y, size, angle, z]) => {
      sticker.style.setProperty(`--${prefix}x`, x + '%');
      sticker.style.setProperty(`--${prefix}y`, y + '%');
      sticker.style.setProperty(`--${prefix}s`, size);
      sticker.style.setProperty(`--${prefix}a`, angle + 'deg');
      sticker.style.setProperty(`--${prefix}z`, z);
    };
    if (desk) set('d', desk);
    if (mob) set('m', mob);
    // Scroll drift pushes each sticker away from the wordmark; wings only drift outward,
    // never down into the trust row.
    const [x, y] = desk || mob;
    const wing = y > 100;
    sticker.dataset.driftX = Math.round((x - 50) * (wing ? .4 : .9));
    sticker.dataset.driftY = wing ? 0 : Math.round((y - 50) * .6);
    sticker.dataset.turn = (index % 2 ? 1 : -1) * (4 + index % 5);
    // 10/17 Josh: "a bit more motion to them as they sit… so you can tell they are live" (was 12-17 s).
    sticker.style.setProperty('--float-period', (7 + (index * 7) % 4) + 's');
    sticker.style.setProperty('--float-delay', -((index * 1.7) % 8).toFixed(1) + 's');
    const image = new Image(width, height);
    image.alt = '';
    image.decoding = 'async';
    image.draggable = false;
    // Band-sized copy (tools/header-art/build_hdr.py), at home.html's preload URL when it has one so that early
    // download is reused; the full art only loads if a copy is missing.
    image.dataset.src = document.querySelector(`link[rel=preload][data-art="${name}"]`)?.href || (window.VP_CDN+"vp-stickers__hdr__") + name + '.webp';
    image.dataset.full = full;
    sticker.append(image);
    fragment.append(sticker);
    items.push({ el: sticker, name, desk, mob, wing, aspect: height / width, mask: outline(name), fillsFall: role === 'fill-fall', tightPlate: role === 'tight-plate' });
  });
  artwork.append(fragment);

  function sizeUnit() {
    const rect = header.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    // Keep every slot for layout/motion, but request only art the active CSS displays.
    // This also picks up desktop wings when the window grows past 1180px.
    items.forEach(({ el }) => {
      const image = el.querySelector('img[data-src]');
      if (!image || getComputedStyle(el).display === 'none') return;
      loadArt(image);
    });
    const fit = frameFor(rect);
    header.style.setProperty('--u', (fit.f.unit * fit.s).toFixed(3) + 'px');
    place(rect, fit);
  }
  const hero = document.querySelector('.home-page .hero-card');
  const sparkHost = document.querySelector('.home-page .home-sparks');
  sizeUnit();
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(sizeUnit);
    observer.observe(header);
    if (hero) observer.observe(hero);
  } else addEventListener('resize', sizeUnit, { passive: true });
  phone.addEventListener?.('change', sizeUnit);
  matchMedia(`(min-width: ${WINGS_MIN}px)`).addEventListener('change', sizeUnit);
  addEventListener('vp-parachute-path', sizeUnit);
  document.fonts?.ready.then(sizeUnit);

  // 10/17 Josh: stickers "sometimes just load as black bounding boxes for a moment before they load in". Safari can
  // paint a half-downloaded image without its alpha, so each sticker stays hidden (header-v13.css) until its art is
  // fully loaded and decoded, then fades in.
  function loadArt(image) {
    image.addEventListener('load', () => image.decode().catch(() => {}).then(() => image.classList.add('is-ready')));
    image.addEventListener('error', () => {
      const full = image.dataset.full;
      image.removeAttribute('data-full');
      if (full) image.src = full;
    });
    image.src = image.dataset.src;
    image.removeAttribute('data-src');
  }

  // Coarse alpha outline (home-collage-masks.js) -> opaque cells, plus a one-cell grown copy
  // used for lookups so neighbours keep a small gap instead of just touching.
  function outline(name) {
    const entry = (window.VP_COLLAGE_MASKS || {})[name];
    if (!entry) return null;
    const [cols, rows, data] = entry;
    const bytes = Uint8Array.from(atob(data), c => c.charCodeAt(0));
    const on = new Uint8Array(cols * rows);
    for (let i = 0; i < on.length; i++) on[i] = bytes[i >> 3] >> (i & 7) & 1;
    const grown = new Uint8Array(on.length);
    for (let r = 0; r < rows; r++) for (let c = 0; c < cols; c++) {
      if (!on[r * cols + c]) continue;
      for (let dr = -1; dr <= 1; dr++) for (let dc = -1; dc <= 1; dc++) {
        const rr = r + dr, cc = c + dc;
        if (rr >= 0 && rr < rows && cc >= 0 && cc < cols) grown[rr * cols + cc] = 1;
      }
    }
    return { cols, rows, on, grown };
  }

  // Layout. Every sticker goes to its frame spot, scaled to this window (spotX/spotY, width = size x unit x s).
  // Because the band, plate and stickers all scale together, nothing collides that didn't collide in Josh's
  // approved picture, and the guard below finds nothing to do (data-collage-fit ends ":0:0"). It stays as a
  // safety net for window shapes nobody has tried: overlapping neighbours push apart, stickers slide off the
  // plate / hero copy / pause button and stay on the page, and a still-wedged sticker shrinks 6% per retry.
  function place(rect, { f, s, sx }) {
    const small = phone.matches;
    const W = rect.width, H = rect.height;
    const within = el => el && el.getClientRects().length && getComputedStyle(el).display !== 'none';
    const box = (el, pad) => {
      if (!within(el)) return null;
      const r = el.getBoundingClientRect();
      return { x0: r.left - rect.left - pad, y0: r.top - rect.top - pad, x1: r.right - rect.left + pad, y1: r.bottom - rect.top + pad };
    };
    const heroBox = sel => box(hero?.querySelector(sel), 0);
    // The parachute's whole fall, from its start by the wordmark to its landing beside the
    // sub-line (home-parachute.js publishes the start as data-fall), so no sticker sits in its way.
    // Phone keeps just the parcel's current spot.
    const fallBox = () => {
      const parcel = document.querySelector('.hero-side-icon.balloon'), now = box(parcel, 8);
      if (!now || small) return now;
      const tx = parseFloat(parcel.style.getPropertyValue('--parcel-travel-x')) || 0;
      const ty = parseFloat(parcel.style.getPropertyValue('--parcel-travel-y')) || 0;
      const [fx, fy] = (parcel.dataset.fall || '0,0').split(',').map(v => Number(v) || 0);
      const land = { x0: now.x0 - tx, y0: now.y0 - ty, x1: now.x1 - tx, y1: now.y1 - ty };
      return { x0: Math.min(land.x0, land.x0 + fx), x1: Math.max(land.x1, land.x1 + fx),
        y0: Math.min(land.y0, land.y0 + fy), y1: Math.max(land.y1, land.y1 + fy) };
    };
    const title = heroBox('.headline-title'), trust = heroBox('.hero-trust');
    const heroTop = hero && within(hero) ? hero.getBoundingClientRect().top - rect.top : H;
    const heroBottom = trust ? trust.y0 : heroTop + 300;
    const wingsOn = !small && innerWidth >= WINGS_MIN;
    // 10/17 Josh ("the corn keeps drooping onto the tree and the pumpkin", 1697x1210): wings sit beside the hero copy,
    // which grows far less than the band on big windows (there: band x1.31, copy x1.05). Sized with the band they
    // packed into the same height and the corn sat on the tree and pumpkin, so wings scale with the copy instead
    // (never past the band's scale) and the wing column stays Josh's locked picture.
    const ws = small ? s : Math.min(s, (heroBottom - heroTop) / f.heroH);
    // Frame spot -> this band. Band y scales about the band's middle; wing y follows the hero copy.
    const spotX = x => W / 2 + (x / 100 - .5) * f.w * sx;
    const spotY = (y, wing) => wing ? heroTop + (y - 100) / 100 * (heroBottom - heroTop) : H / 2 + (y / 100 - .5) * f.h * s;
    const fall = fallBox();
    const plate = box(header.querySelector('.hero-wordmark-box'), 10 * s);
    const bandRocks = [plate, box(header.querySelector('.header-motion'), 8),
      fall, box(hero?.querySelector('.headline-title'), 12 * s)].filter(Boolean);
    // The fill cloud takes the parachute's starting spot once it drops, so the parcel isn't a rock for it.
    const fillRocks = bandRocks.filter(rock => rock !== fall);
    // Phone top-left VP (Josh 10/12: a bit larger and lower, centred in its corner): only a 3 px gap to the plate.
    const tightPlate = box(header.querySelector('.hero-wordmark-box'), 3 * s);
    const tightRocks = bandRocks.map(rock => rock === plate && tightPlate ? tightPlate : rock);
    const copyRocks = ['.headline-sub', '.hero-eta-copy', '.hero-eta-truck', '.hero-cta', '.hero-side-icon.hand']
      .map(sel => box(hero?.querySelector(sel), 22 * s)).filter(Boolean);
    // Phone hero spots dodge the words themselves (the phone copy blocks are full-width boxes), the truck and the button.
    const runRocks = (sel, padding) => textRuns(hero?.querySelector(sel)).map(run => ({ x0: run.left - rect.left - padding,
      y0: run.top - rect.top - padding, x1: run.right - rect.left + padding, y1: run.bottom - rect.top + padding }));
    const wingRocks = small
      ? [...runRocks('.headline-title', 8 * s), ...runRocks('.headline-sub', 8 * s), ...runRocks('.hero-eta-copy', 8 * s),
        ...['.hero-eta-truck', '.hero-cta', '.hero-side-icon.balloon'].map(sel => box(hero?.querySelector(sel), 8 * s))].filter(Boolean)
      : [box(hero?.querySelector('.headline-title'), 22 * s), ...copyRocks, fall].filter(Boolean);
    // The desktop sun lives in the fall itself (fill-fall) beside the copy, so the fall is not a rock for it and the
    // copy counts as its words (text runs), the truck, the button and the hand, not the full-width copy boxes.
    const wingFillRocks = [...runRocks('.headline-title', 12 * s),
      ...runRocks('.headline-sub', 12 * s), ...runRocks('.hero-eta-copy', 12 * s),
      ...['.hero-eta-truck', '.hero-cta', '.hero-side-icon.hand'].map(sel => box(hero?.querySelector(sel), 14 * s))].filter(Boolean);
    const pad = f.pad * s;
    // Wings are a desktop idea (desktop y > 100); on phone every sticker uses its own phone spot.
    const isWing = item => small ? !!item.mob && item.mob[1] > 100 : item.wing;
    const live = items.filter(item => (small ? item.mob : item.desk) && item.mask && (!isWing(item) || small || wingsOn));
    const scale = new Map(live.map(item => [item, 1]));
    let best = null;
    for (let attempt = 0; attempt < 7; attempt++) {
      const spots = live.map(item => {
        const [x, y, size, angle] = small ? item.mob : item.desk;
        const k = isWing(item) ? ws : s;
        const w = size * f.unit * k * scale.get(item), h = w * item.aspect, a = angle * Math.PI / 180, cos = Math.cos(a), sin = Math.sin(a);
        const { cols, rows, on } = item.mask;
        const pts = [];
        let minX = 1e9, maxX = -1e9, minY = 1e9, maxY = -1e9;
        for (let r = 0; r < rows; r++) for (let c = 0; c < cols; c++) {
          if (!on[r * cols + c]) continue;
          const qx = (c + .5) / cols * w - .5 * w, qy = (r + .5) / rows * h - .55 * h;
          const dx = cos * qx - sin * qy, dy = sin * qx + cos * qy + .05 * h;
          pts.push(dx, dy);
          minX = Math.min(minX, dx); maxX = Math.max(maxX, dx); minY = Math.min(minY, dy); maxY = Math.max(maxY, dy);
        }
        const tx = spotX(x), ty = spotY(y, isWing(item));
        const yTop = (isWing(item) ? heroTop : 0) + 6 * k;
        // With wings on, a band sticker may hang past the band beside the copy (the pine tree);
        // it then dodges the sub, CTA and hand too.
        const hang = isWing(item) || wingsOn;
        const yBottom = hang ? heroBottom - 10 * k :Math.min(title ? title.y0 - 10 * s : H + 40 * s, H + 40 * s);
        return { item, w, h, cos, sin, pts, cell: Math.sqrt(w * h / (cols * rows)), tx, ty, x: tx, y: ty,
          ext: [minX, maxX, minY, maxY], yTop, yBottom, rocks: isWing(item) ? (item.fillsFall ? wingFillRocks : wingRocks) : wingsOn ? bandRocks.concat(copyRocks) : item.fillsFall ? fillRocks : small && item.tightPlate ? tightRocks : bandRocks,
          radius: Math.hypot(w, h) / 2 + 4, stuck: 0 };
      });
      const clampIn = p => {
        p.x = Math.min(Math.max(p.x, pad - p.ext[0]), W - pad - p.ext[1]);
        p.y = Math.min(Math.max(p.y, p.yTop - p.ext[2]), Math.max(p.yTop - p.ext[2], p.yBottom - p.ext[3]));
      };
      // Count p's outline cells that land inside q's grown outline; returns [cells, area].
      const hit = (p, q) => {
        const { cols, rows, grown } = q.item.mask;
        let n = 0;
        for (let k = 0; k < p.pts.length; k += 2) {
          const gx = p.x + p.pts[k] - q.x, gy = p.y + p.pts[k + 1] - q.y - .05 * q.h;
          const lx = q.cos * gx + q.sin * gy + .5 * q.w, ly = -q.sin * gx + q.cos * gy + .55 * q.h;
          const c = Math.floor(lx / q.w * cols), r = Math.floor(ly / q.h * rows);
          if (c >= 0 && c < cols && r >= 0 && r < rows && grown[r * cols + c]) n++;
        }
        return n * p.cell * p.cell;
      };
      const ITER = 120;
      let residual = 0;
      spots.forEach(clampIn);
      for (let it = 0; it < ITER; it++) {
        residual = 0;
        spots.forEach(p => { p.stuck = 0; });
        for (let i = 0; i < spots.length; i++) for (let j = i + 1; j < spots.length; j++) {
          const p = spots[i], q = spots[j];
          let dx = p.x - q.x, dy = p.y - q.y;
          const dist = Math.hypot(dx, dy);
          if (dist > p.radius + q.radius) continue;
          const area = Math.max(hit(p, q), hit(q, p));
          if (!area) continue;
          residual += area;
          p.stuck += area; q.stuck += area;
          if (dist < .01) { dx = 1; dy = 0; } else { dx /= dist; dy /= dist; }
          const step = Math.min(10, 1 + .12 * Math.sqrt(area)), share = p.w * p.h / (p.w * p.h + q.w * q.h);
          p.x += dx * step * (1 - share); p.y += dy * step * (1 - share);
          q.x -= dx * step * share; q.y -= dy * step * share;
        }
        spots.forEach(p => {
          p.rocks.forEach(rock => {
            let n = 0, px = 0, py = 0;
            for (let k = 0; k < p.pts.length; k += 2) {
              const X = p.x + p.pts[k], Y = p.y + p.pts[k + 1];
              if (X <= rock.x0 || X >= rock.x1 || Y <= rock.y0 || Y >= rock.y1) continue;
              const out = [rock.x0 - X, rock.x1 - X, rock.y0 - Y, rock.y1 - Y];
              const m = out.reduce((b, v, i) => Math.abs(v) < Math.abs(out[b]) ? i : b, 0);
              if (m < 2) px += out[m]; else py += out[m];
              n++;
            }
            if (!n) return;
            residual += n * p.cell * p.cell;
            p.stuck += n * p.cell * p.cell;
            p.x += Math.max(-12, Math.min(12, px / n * .5 + Math.sign(px)));
            p.y += Math.max(-12, Math.min(12, py / n * .5 + Math.sign(py)));
          });
          const k = .05 * (1 - it / ITER);
          p.x += (p.tx - p.x) * k; p.y += (p.ty - p.y) * k;
          clampIn(p);
        });
      }
      if (!best || residual < best.residual) best = { spots, residual, attempt };
      if (residual < 1) break;
      spots.forEach(p => { if (p.stuck >= 1) scale.set(p.item, scale.get(p.item) * .94); });
    }
    // attempt:residual:largest move off the frame spot (px). "0:0:0" = the approved picture, untouched.
    const moved = Math.max(0, ...best.spots.map(p => Math.hypot(p.x - p.tx, p.y - p.ty)));
    header.dataset.collageFit = best.attempt + ':' + Math.round(best.residual) + ':' + Math.round(moved);
    geom = { small, W, H, f, s, sx, ws, heroTop, heroBottom };
    items.forEach(item => { item.el.style.left = item.el.style.top = item.el.style.width = ''; });
    best.spots.forEach(p => {
      p.item.el.style.left = p.x.toFixed(1) + 'px';
      p.item.el.style.top = p.y.toFixed(1) + 'px';
      p.item.el.style.width = p.w.toFixed(1) + 'px';
    });
    // Accent stars: same frames; the ones below the band show only with the wings. The hero copy keeps its
    // readable minimum sizes on small screens, so a star that would touch the words, buttons, truck, hand or the
    // parachute's landing spot is left out rather than moved.
    if (sparkHost) {
      const host = sparkHost.getBoundingClientRect();
      const copy = [...textRuns(hero?.querySelector('.headline-title')), ...textRuns(hero?.querySelector('.headline-sub')),
        ...textRuns(hero?.querySelector('.hero-eta-copy')),
        ...['.hero-eta-truck', '.hero-cta', '.hero-side-icon.hand', '.hero-side-icon.balloon']
          .map(sel => hero?.querySelector(sel)).filter(within).map(el => el.getBoundingClientRect())];
      SPARKS.forEach(([name, desk, mob]) => {
        const el = sparkHost.querySelector('.home-spark.' + name), spot = small ? mob : desk;
        if (!el) return;
        let show = !!spot && (small || spot[1] <= 100 || wingsOn);
        if (show) {
          const k = spot[1] > 100 ? ws : s;
          const x = rect.left + spotX(spot[0]), y = rect.top + spotY(spot[1], spot[1] > 100), r = spot[2] * f.unit * k / 2 + 6 * k;
          show = !copy.some(c => x + r > c.left && x - r < c.right && y + r > c.top && y - r < c.bottom);
          el.style.setProperty('--sx', (x - host.left).toFixed(1) + 'px');
          el.style.setProperty('--sy', (y - host.top).toFixed(1) + 'px');
          el.style.setProperty('--ss', (spot[2] * f.unit * k).toFixed(1) + 'px');
        }
        el.style.display = show ? '' : 'none';
      });
    }
  }

  // The glyph boxes of an element's text, one per line run (not its full-width block box).
  function textRuns(el) {
    if (!el || !el.getClientRects().length) return [];
    const runs = [], walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
      if (!node.textContent.trim()) continue;
      const range = document.createRange();
      range.selectNodeContents(node);
      for (const run of range.getClientRects()) if (run.width && run.height) runs.push(run);
    }
    return runs;
  }

  arrangeMode();

  // Arrange mode (?arrange=1, kept for the tab): Josh drags the desktop stickers where he wants them, then
  // "Copy layout" copies every desktop row as [x%, y%, size, angle, z] (as seen, drags included) to paste into LAYOUT.
  function arrangeMode() {
    let on = false;
    try {
      if (/[?&]arrange=1/.test(location.search)) sessionStorage.setItem('vp_arrange', '1');
      if (/[?&]arrange=0/.test(location.search)) sessionStorage.removeItem('vp_arrange');
      on = sessionStorage.getItem('vp_arrange') === '1';
    } catch (error) { on = /[?&]arrange=1/.test(location.search); }
    if (!on) return;
    const bar = document.createElement('div');
    bar.className = 'vp-arrange-bar';
    bar.innerHTML = '<button type="button">Copy layout</button><textarea readonly rows="3" hidden></textarea>';
    document.body.append(bar);
    const button = bar.querySelector('button'), out = bar.querySelector('textarea');
    button.addEventListener('click', () => {
      if (!geom || geom.small) { button.textContent = 'Desktop only'; return; }
      const { W, H, f, s, sx, ws, heroTop, heroBottom } = geom;
      const round = v => Math.round(v * 10) / 10;
      const rows = items.filter(item => item.desk && item.el.offsetParent).map(item => {
        const el = item.el;
        const cx = parseFloat(el.style.left) + (parseFloat(el.style.getPropertyValue('--drag-x')) || 0);
        const cy = parseFloat(el.style.top) + (parseFloat(el.style.getPropertyValue('--drag-y')) || 0);
        // Rows come out in frame coordinates (the inverse of spotX/spotY), so they paste straight into LAYOUT at any
        // window size. Anything below the band reads as a hero wing (100 = hero top, 200 = trust line).
        let y = ((cy - H / 2) / (f.h * s) + .5) * 100;
        if (cy > H) y = 100 + (cy - heroTop) / (heroBottom - heroTop) * 100;
        const [, , , angle, z] = item.desk;
        return `['${item.name}', [${round(((cx - W / 2) / (f.w * sx) + .5) * 100)}, ${round(y)}, ${round(parseFloat(el.style.width) / (f.unit * (item.wing ? ws : s)))}, ${angle}, ${z}]]`;
      });
      const text = `// ${innerWidth}x${innerHeight}\n` + rows.join(',\n');
      out.value = text;
      out.hidden = false;
      console.log(text);
      navigator.clipboard?.writeText(text).then(() => { button.textContent = 'Copied ✓'; }, () => { button.textContent = 'Copy from the box'; out.select(); });
      setTimeout(() => { button.textContent = 'Copy layout'; }, 2500);
    });
  }

  // Peel and move lives in header-v13.js now (every page, every pointer).
  arriveOnDrop(items.find(item => item.name === 'cardinal'), 'is-swing-wait', 'is-swinging');
  arriveOnDrop(items.find(item => item.fillsFall && item.mob), 'is-drift-wait', 'is-drifting');
  leaveOnFall(items.find(item => item.name === 'sun' && item.desk));
  arriveOnDrop(items.find(item => item.name === 'sun' && !item.desk), 'is-slide-wait', 'is-sliding');

  // Phone, motion on (Josh 10/12): the cardinal waits off to the right and swings in to its top-row spot, and the
  // fill cloud drifts into the parachute's starting spot, the moment the parachute starts to drop
  // (home-parachute.js fires vp-parachute-drop). Paused, reduced motion or desktop: they just sit there.
  // If the drop never comes, they arrive anyway.
  function arriveOnDrop(item, waitClass, runClass) {
    if (!item) return;
    const el = item.el;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let fallback = 0, done = false, armed = false;
    const motionOn = () => header.dataset.motion === 'on' && !reduced.matches;
    const finish = swing => {
      if (done) return;
      done = true;
      clearTimeout(fallback);
      removeEventListener('vp-parachute-drop', land);
      if (!el.classList.contains(waitClass)) return;
      el.classList.remove(waitClass);
      if (!swing) return;
      el.classList.add(runClass);
      el.addEventListener('animationend', () => el.classList.remove(runClass), { once: true });
    };
    const land = () => finish(true);
    const arm = () => {
      if (armed || done) return;
      // header-v13.js sets data-motion once it runs; until then wait (the drop can't start either).
      if (!header.dataset.motion) return;
      armed = true;
      if (!phone.matches || !motionOn()) { done = true; return; }
      el.classList.add(waitClass);
      if (document.documentElement.dataset.vpParachuteDrop) { land(); return; }
      addEventListener('vp-parachute-drop', land);
      fallback = setTimeout(land, 4000);
    };
    // Leaving the phone layout or turning motion off before the drop: show it in place.
    const settle = () => {
      arm();
      if (armed && !done && !(phone.matches && motionOn())) finish(false);
    };
    phone.addEventListener?.('change', settle);
    reduced.addEventListener?.('change', settle);
    new MutationObserver(settle).observe(header, { attributes: true, attributeFilter: ['data-motion'] });
    arm();
  }

  // Desktop, motion on (Josh 10/19): the sun fills the parachute's landing spot. Its exit is SCROLL-DRIVEN like the
  // parachute ("it needs to kinda go with the motion so if i scroll back up it comes back"): the first ~45% of the
  // parcel's scroll range rolls the sun down to the field's bottom edge, hops it under the pumpkin (which lifts out of
  // its way) and off the right edge of the band; scrolling back brings everything back the same way. A little easing
  // keeps it calm on a flick. While the sun still blocks the landing column, data-vp-sun-hold on <html> keeps the
  // parcel above the hole (home-parachute.js). Motion off / reduced: the parcel parks on the landing spot, so the sun
  // is hidden. Phone: nothing (the phone sun is its own item).
  function leaveOnFall(item) {
    if (!item) return;
    const el = item.el, img = el.querySelector('img');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    // Josh 10/19 06:33 ("way too fast again, CALM"): the sun follows the scroll at a capped pace, RATE of the path per
    // second (≈3.5 s end to end) with a soft landing (GAIN per second when close), however hard the wheel is spun.
    // The sun's target reaches the end of its path when the scroll would land the parcel; the parcel waits for it.
    const SUN_SHARE = 1, RATE = .28, GAIN = 3, LIFT = 30;
    let raf = 0, hidden = false, shown = 0, path = null, pathKey = '', lastT = 0, staleLater = false, vel = 0;
    const pumpkinEl = () => items.find(i => i.name === 'pumpkin' && i.desk)?.el;
    const parcelEl = () => document.querySelector('.hero-side-icon.balloon');
    const hold = on => { if (on) document.documentElement.dataset.vpSunHold = '1'; else delete document.documentElement.dataset.vpSunHold; };
    const num = (node, name) => parseFloat(node.style.getPropertyValue(name)) || 0;
    const clamp01 = v => Math.max(0, Math.min(1, v));
    const smooth = (a, b, v) => { const t = clamp01((v - a) / (b - a)); return t * t * (3 - 2 * t); };

    // Path in header px, from the sun's own frame spot: measured when needed and again when the window changes.
    const measure = () => {
      const rect = header.getBoundingClientRect(), W = header.clientWidth;
      const trust = document.querySelector('.home-page .hero-trust');
      const pumpkin = pumpkinEl();
      const cx = el.offsetLeft + num(el, '--drag-x'), cy = el.offsetTop + num(el, '--drag-y'), hw = el.offsetWidth / 2;
      if (path && pathKey) return path;
      pathKey = 'measured';
      const floor = trust?.getClientRects().length ? trust.getBoundingClientRect().top - rect.top : rect.height;
      const pk = pumpkin && pumpkin.offsetParent ? {
        left: pumpkin.offsetLeft + num(pumpkin, '--drag-x') - pumpkin.offsetWidth / 2,
        bottom: pumpkin.offsetTop + num(pumpkin, '--drag-y') + pumpkin.offsetHeight / 2
      } : { left: W - hw * 3, bottom: cy };
      // Lands on the bottom edge just left of the pumpkin (8 px off the edge: idle float and tilt swell the art), hops
      // under the lifted pumpkin, exits off the right edge. If the gap under the pumpkin is tighter than the sun, it
      // shrinks just enough to fit.
      const y1 = floor - hw - 8;
      const room = y1 - hw - (pk.bottom + 12);
      const scale = room < 0 ? Math.max(.6, (y1 - (pk.bottom + 12)) / hw) : 1;
      const x1 = Math.max(cx + hw, Math.min(pk.left - hw * .7, W - hw));
      const x2 = W + hw * scale + 16, hop = Math.min(18, Math.max(0, room + LIFT - 10));
      // One smooth curve, travelled at constant speed (sampled by arc length): a gravity-style arc down to the contact
      // point, a direction change there (the bounce), then a low arc under the pumpkin and out. No speed jumps.
      const P0 = [0, 0], P1 = [x1 - cx, y1 - cy], P2 = [x2 - cx, y1 - cy];
      const C0 = [P0[0] + (P1[0] - P0[0]) * .45, P0[1] + (P1[1] - P0[1]) * .05];
      const C1 = [(P1[0] + P2[0]) / 2, P1[1] - hop * 2];
      const q = (a, c, b, t) => [(1 - t) * (1 - t) * a[0] + 2 * (1 - t) * t * c[0] + t * t * b[0], (1 - t) * (1 - t) * a[1] + 2 * (1 - t) * t * c[1] + t * t * b[1]];
      const pts = [], cum = [0];
      for (let k = 0; k <= 120; k++) pts.push(q(P0, C0, P1, k / 120));
      for (let k = 1; k <= 120; k++) pts.push(q(P1, C1, P2, k / 120));
      for (let k = 1; k < pts.length; k++) cum.push(cum[k - 1] + Math.hypot(pts[k][0] - pts[k - 1][0], pts[k][1] - pts[k - 1][1]));
      path = { pts, cum, len: cum[cum.length - 1], scale };
      return path;
    };
    const at = (u, P) => {
      const d = u * P.len;
      let lo = 0, hi = P.cum.length - 1;
      while (hi - lo > 1) { const mid = (lo + hi) >> 1; if (P.cum[mid] <= d) lo = mid; else hi = mid; }
      const span = P.cum[hi] - P.cum[lo] || 1, t = (d - P.cum[lo]) / span;
      return [P.pts[lo][0] + (P.pts[hi][0] - P.pts[lo][0]) * t, P.pts[lo][1] + (P.pts[hi][1] - P.pts[lo][1]) * t];
    };

    const paint = u => {
      const P = path && pathKey ? path : measure();
      const [x, y] = at(u, P);
      el.style.translate = u <= 0 ? '' : `${x.toFixed(1)}px ${y.toFixed(1)}px`;
      el.style.scale = u <= 0 || P.scale === 1 ? '' : String(1 + (P.scale - 1) * smooth(0, .5, u));
      if (img) img.style.rotate = u <= 0 ? '' : (780 * u).toFixed(1) + 'deg';
      el.classList.toggle('is-on-path', u > .02);
      const pumpkin = pumpkinEl();
      if (pumpkin) {
        const lift = LIFT * smooth(.08, .4, u) * (1 - smooth(.84, 1, u));
        pumpkin.style.translate = lift < .5 ? '' : `0 ${(-lift).toFixed(1)}px`;
      }
    };
    const landingBox = () => {
      const parcel = parcelEl();
      if (!parcel) return null;
      const r = parcel.getBoundingClientRect(), tx = num(parcel, '--parcel-travel-x'), ty = num(parcel, '--parcel-travel-y');
      return { x0: r.left - tx, y0: r.top - ty, x1: r.right - tx, y1: r.bottom - ty };
    };
    // The sun rolls right and down through the parcel's landing column: it is clear once wholly past the landing's
    // right side or wholly below its bottom (10 px to spare).
    const blocking = () => {
      const land = landingBox(), r = el.getBoundingClientRect();
      if (!land || !r.width) return false;
      return !(r.left > land.x1 + 10 || r.top > land.y1 + 10);
    };
    const hide = () => { if (hidden) return; hidden = true; paint(0); el.classList.add('is-gone'); hold(false); };
    const unhide = () => { if (!hidden) return; hidden = false; el.classList.remove('is-gone'); };

    // Target = how far along the path the scroll says the sun should be: the parcel's own scroll range x SUN_SHARE.
    const target = parcel => {
      const fall = parseFloat(parcel.dataset.fall?.split(',')[1]) || 0;
      const end = Math.abs(fall) * .88; // home-parachute.js: descent spread over .88 of the fall
      return end ? clamp01((window.scrollY || 0) / (end * SUN_SHARE)) : 0;
    };
    const step = () => {
      raf = 0;
      if (phone.matches || innerWidth < WINGS_MIN || el.offsetParent === null && !hidden) { hold(false); return; }
      const parcel = parcelEl();
      if (!parcel || !parcel.classList.contains('is-parachute-ready') || !header.dataset.motion) { setTimeout(ask, 120); return; }
      const motion = header.dataset.motion === 'on' && !reduced.matches;
      if (!motion || parcel.classList.contains('is-parachute-parked')) { hide(); return; }
      unhide();
      const now = performance.now(), dt = lastT ? Math.min(.05, (now - lastT) / 1000) : 1 / 60;
      lastT = now;
      const want = target(parcel);
      const gap = want - shown;
      // Velocity eases toward its target (capped at RATE, proportional near the end), so starts, stops and reversals
      // are soft rather than stepped.
      const vTarget = Math.sign(gap) * Math.min(RATE, Math.abs(gap) * GAIN);
      vel += (vTarget - vel) * Math.min(1, dt * 7);
      const move = Math.min(Math.abs(gap), Math.abs(vel) * dt);
      shown = Math.abs(gap) < .003 ? want : shown + Math.sign(gap) * move;
      if (shown === want) vel = 0;
      if (shown === 0 && staleLater) { staleLater = false; pathKey = ''; }
      paint(shown);
      hold(shown < 1 && blocking());
      if (shown !== want) ask(); else lastT = 0;
    };
    const ask = () => { if (!raf) raf = requestAnimationFrame(step); };
    addEventListener('scroll', ask, { passive: true });
    const stale = () => { if (shown === 0) pathKey = ''; else staleLater = true; ask(); };
    addEventListener('resize', stale);
    addEventListener('vp-parachute-path', stale);
    reduced.addEventListener?.('change', ask);
    phone.addEventListener?.('change', ask);
    new MutationObserver(ask).observe(header, { attributes: true, attributeFilter: ['data-motion'] });
    ask();
  }
  }
})();